<template>
    <div  class="lg:w-[300px] mlg:w-[350px] bg-background-1 h-[146px] absolute bottom-4 right-4 z-[9999999] rounded p-4 flex flex-col">
        <div class="text-body-4 text-white">{{ formattedTitle }}</div>
        <div class="w-full flex-1 flex overflow-y-scroll no-scrollbar mt-4 flex-col">
            <div
                class="w-full flex justify-between items-center"
                v-for="file in files"
                :key="file.uid"
            >
                <UploadedDocumentRow :document="file" />
            </div>
        </div>
    </div>
</template>
<script setup>
import UploadedDocumentRow from "@/components/custom/documents/UploadedDocumentRow.vue";
import {computed} from "vue";

const props = defineProps({
    files: {
        type: Array,
        default: () => [],
    },
});

const formattedTitle = computed(() => {
    const word = props.files.length === 1 ? 'upload' : 'uploads';
    return `${props.files.length} ${word} completed`;
});
</script>